import axios from 'axios';
import Cookies from 'js-cookie';
import { GMB } from '../../../services/gmbApiConfig';

// Generates a presigned url to upload images to S3
export const getPresignedUrl = async ({ account_id, location_id }) => {
    try {
        const response = await axios.post(
            `${GMB.ENDPOINTS.POSTS.IMAGES.GET_PRESIGNED_URL_TO_UPLOAD_POSTS}`,
            { account_id, location_id },
            {
                headers: {
                    Authorization: Cookies.get("ssp_sso_token"),
                    "Content-Type": "application/json",
                },
            },
        );
        if (response.status !== 200) {
            throw new Error(response.data.error_message);
        }
        console.log("getPresignedUrl response",response.data)
        return response.data;
    } catch (error) {
        throw new Error("Failed to get presigned URL");
    }
};
